import useFormSchema from '@/composables/useFormSchema'
import { InvoicesFormFields, RenderedForm } from '@/components/billing/InvoicesTab/types/InvoicesTabComponentTypes'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { computed } from 'vue'
import { isTrue } from '@/helpers/boolean'

export default function useBankdraftForm() {
  const bankdraftFormContext = RenderedForm.CUSTOMER_BANKDRAFTS_DETAIL_FORM
  const { formSchema, getFormSchema } = useFormSchema({
    formAlias: bankdraftFormContext,
    context: bankdraftFormContext
  })
  const bankdraftFormSchema = formSchema
  const loadBankdata = async () => store.dispatch(`${ModuleNamespaces.FACTURA_E}/fetchBankdata`)
  const loadBankdraftFormSchema = getFormSchema
  const setPaymentTypeId = (paymentType: string) => store.dispatch(`${ ModuleNamespaces.FACTURA_E }/setPaymentType`, paymentType)
  const bankdata = computed(() => store.getters[`${ ModuleNamespaces.FACTURA_E }/getBankdata`])
  const isPaymentTypeWithBankdata = computed((): boolean => store.getters[`${ ModuleNamespaces.FACTURA_E }/isPaymentTypeWithBankdata`])
  const isDirectDebitWithoutBankdata = computed((): boolean => store.getters[`${ ModuleNamespaces.FACTURA_E }/isDirectDebitWithoutBankdata`])
  const saveBankdraftForm = (bankdraft: object, customerInvoiceId: number) => store.dispatch(
    `${ ModuleNamespaces.INVOICES }/saveInvoiceDetail`, {
      endpoint: '/invoices/customers/bankdraft/save',
      formData: {
        ...bankdraft,
        idInvoice: String(customerInvoiceId)
      }
    }
  )
  const validateSageExported = (bankdraft: any): void => {
    const field = bankdraftFormSchema.value?.find((item: any) => item.id === InvoicesFormFields.SAGE_EXPORTED_ALERT) as any
    if (field) {
      field.hidden = !isTrue(bankdraft?.exportado_sage)
    }
  }
  return {
    loadBankdata,
    setPaymentTypeId,
    isDirectDebitWithoutBankdata,
    bankdata,
    isPaymentTypeWithBankdata,
    bankdraftFormContext,
    bankdraftFormSchema,
    loadBankdraftFormSchema,
    saveBankdraftForm,
    validateSageExported
  }
}
